import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as homePageActions from "../../actions/homePageActions";
import * as settingActions from "../../actions/settingActions";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import Details from "./details";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropTypes from "prop-types";

const Index = (props) => {
  const { actions, setting,  homePageData, advisors, teams, } = props;
  
  const Members = {
    dots: false,
    infinite: advisors && advisors.length > 1,
    centerpadding: 0,
    speed: 500,
    slidesToShow: Math.min(advisors?.length ?? 0, 4),
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: Math.min(advisors?.length ?? 0, 3),
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: Math.min(advisors?.length ?? 0, 2),
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const prepareHtml = (description = "") => ({
    __html: description,
  });

  useEffect(() => {
    const fetchData = () => {
      actions.loadHomePageData("about-us");
      // Remove loadLeaderData as it's not needed for teams/advisors
      // The loadHomePageData already calls loadAdvisorsData and loadTeamsData
    };
    fetchData();
  }, [actions]);

  const siteName = setting?.name?.trim() || `About Us`;

  useEffect(() => {
    const title = `${siteName} - About Us`;

    document.title = title;
    document.querySelector('meta[name="description"]').setAttribute('content', homePageData?.meta_description);
  }, [siteName, homePageData?.meta_description]);

  const moduleRenderData = setting?.module_data
  const isSectionShow = (name) => {
    return moduleRenderData?.some((item) => item?.name === name && item?.status === "Enabled" && item?.is_default === "Yes")
  }

  const [modalShow, setModalShow] = useState(false);
  const [userData, setUserData] = useState({});

  const getUserDetails = (
    e, {
      full_name,
      image,
      organization,
      position,
      about,
      linkedin,
      main_area
    }) => {
    e.preventDefault();
    setModalShow(true);
    setUserData({
      full_name: full_name,
      image: image,
      organization: organization,
      position: position,
      about: about,
      linkedin: linkedin,
      main_area: main_area,
    });
  };

  return (

    <div className="about_section">
      <div
        dangerouslySetInnerHTML={prepareHtml(homePageData?.description)}
      ></div>
      {isSectionShow('About us') && <>
        <section className="about_who_sec">
          <Container>
            <Row className="align-items-center">
              <Col lg={6}>
                <div className="about_content">
                  <div className="title">Meet the team</div>
                  <p className="m-0">
                    We are committed diversity champions who truly believe in the power of diverse workplaces
                  </p>
                </div>
              </Col>

              <Col lg={6}>
                <Row className="who-thumb-outer">
                  {teams && teams.length > 0 ? teams.map((item, key) => (
                    <Col key={item.id || item.full_name} sm={6}
                      className={(key === 1 || key === 3) && "mt-md-n5"}
                    >
                      <div className="who_box" key={`team-box-${item.id}`}>
                        <img className="w-100" src={item.image} alt={item.full_name} />
                        <div className="who_info text-left">
                          <div className="hover-part">
                            <p className="positionsh">{item.position}</p>
                            <span className="profile">{item.full_name}</span>
                            <div className="hvrcontant">

                              <p>{item.organization}</p>
                              <a
                                href={item.linkedin_url}
                                className="newcustomelinked text-white m-0"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Linkedin Profile
                              </a>
                              <div>
                                <button
                                  type="button"
                                  className="readmore btn btn-link p-0"
                                  onClick={(e) => getUserDetails(e, item)}
                                >
                                  Read More <i className="fas fa-long-arrow-alt-right"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )) : (
                    <Col sm={12}>
                      <p>No team members found.</p>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="members_sec">
          <Container>
            <div className="title text-center space-bottom">
              Our Advisors
            </div>
            <Slider {...Members}>
              {advisors && advisors.length > 0 ? advisors.map((item, key) => (
                <div key={item.id || item.full_name}>
                  <div className="member_box text-center">
                    <div className="member_img">
                      <img src={item.image} alt={item.full_name} />
                      <div className="advisor-contnt">
                        <p className="positionsh">{item.position}</p>
                        <span className="name d-block pt-2">{item.full_name}</span>
                        <div className="hvrcontant">

                          <p>{item.organization}</p>
                          <a
                            href={item.linkedin_url}
                            className="newcustomelinked text-white m-0"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Linkedin Profile
                          </a>
                          <div>
                            <button
                              type="button"
                              className="readmore btn btn-link p-0"
                              onClick={(e) => getUserDetails(e, item)}
                            >
                              Read More <i className="fas fa-long-arrow-alt-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )) : (
                <div>
                  <p>No advisors found.</p>
                </div>
              )}
            </Slider>
          </Container>
        </section>
      </>
      }
      {modalShow && (
        <Details
          show={modalShow}
          userdata={userData}
          onHide={() => setModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
    </div>
  );
};

Index.propTypes = {
  actions: PropTypes.shape({
    loadHomePageData: PropTypes.func.isRequired,
    loadLeaderData: PropTypes.func.isRequired,
  }).isRequired,

  setting: PropTypes.shape({
    name: PropTypes.string,
    module_data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        status: PropTypes.string,
        is_default: PropTypes.string,
      })
    ),
  }).isRequired,

  homePageData: PropTypes.shape({
    description: PropTypes.string,
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
  }).isRequired,

  advisors: PropTypes.arrayOf(
    PropTypes.shape({
      full_name: PropTypes.string,
      image: PropTypes.string,
      organization: PropTypes.string,
      position: PropTypes.string,
      about: PropTypes.string,
      linkedin_url: PropTypes.string,
      main_area: PropTypes.string,
      length: PropTypes.number,
      map: PropTypes.func,
    })
  ).isRequired,

  teams: PropTypes.arrayOf(
    PropTypes.shape({
      full_name: PropTypes.string,
      image: PropTypes.string,
      organization: PropTypes.string,
      position: PropTypes.string,
      about: PropTypes.string,
      linkedin_url: PropTypes.string,
      main_area: PropTypes.string,
      length: PropTypes.number,
      map: PropTypes.func,
    })
  ).isRequired,
};

function mapStateToProps(state) {
  return {
    homePageData: state.homePageData,
    leaders: state.leaders,
    teams: state.teams,
    setting: state.setting,
    advisors: state.advisors
  };
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...homePageActions,
        ...settingActions
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
